import { Injectable } from "@angular/core";
import {
  Router,
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { ClientService } from "src/app/Services/Client/client.service";
import { IClient } from "src/app/Models/Interface/Client/client";
import { IBaseDataList } from "src/app/Models/Interface/Base/base-data-list";

@Injectable({
  providedIn: "root",
})
export class ClientResolver implements Resolve<IBaseDataList<IClient[]>> {
  constructor(private clientService: ClientService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IBaseDataList<IClient[]>> {
    return this.clientService.getAllClients();
  }
}
